import { render, staticRenderFns } from "./pass-and-card.vue?vue&type=template&id=20512d1e&scoped=true&"
import script from "./pass-and-card.vue?vue&type=script&lang=js&"
export * from "./pass-and-card.vue?vue&type=script&lang=js&"
import style0 from "./pass-and-card.vue?vue&type=style&index=0&id=20512d1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20512d1e",
  null
  
)

export default component.exports